// extracted by mini-css-extract-plugin
export default {"tooltip":"SphereWithEffects_tooltip__OSyoU"};